import * as React from 'react';
import { classNames } from 'primereact/utils';
import { formatRelative } from 'date-fns';
import { TimePeriodServiceGetUploadFilesResponse } from '../../services/api';
import { parseFileReadableFilesize } from '../../utils/parse';

export default function FileSummary({ file }: { file: TimePeriodServiceGetUploadFilesResponse }) {
  return (
    <div className="grid grid-cols-[auto_1fr_auto] items-center gap-2">
      <div
        className={
          classNames(
            "flex items-center justify-center w-8 h-8 text-xl rounded bg-grey-3",
            {
              '!bg-warning-yellow': file.fileType === 'BAFO',
            },
            {
              '!bg-accent-green': file.fileType === 'EmailRetention',
            },

          )
        }
      >
        📊
      </div>
      <div className="flex flex-col text-sm">
        <div>{file.fileName} <strong className="font-normal text-grey-7">{parseFileReadableFilesize(file.fileSizeBytes)}</strong></div>
        <div className="text-grey-7">
          <span className="capitalize">{formatRelative(file.createdDate!, new Date())}</span> by {file.createdBy}
        </div>
      </div>
    </div>
  )
}